import React, { useState } from 'react';
import { Button } from '../ui/button';
import { ShoppingCart, CreditCard, Check, Lightning } from '@phosphor-icons/react';
import { paymentsAPI, formatApiError } from '../../services/api';
import { toast } from 'sonner';

export function StandardBuySection({ product, productId, isAuthenticated, isOwnProduct, formatCurrency, navigate }) {
  const [purchasing, setPurchasing] = useState(false);

  const handlePurchase = async () => {
    if (!isAuthenticated) {
      toast.error('Please login to purchase');
      navigate('/login');
      return;
    }
    setPurchasing(true);
    try {
      const response = await paymentsAPI.checkoutProduct(productId, window.location.origin);
      window.location.href = response.data.url;
    } catch (error) {
      toast.error(formatApiError(error));
      setPurchasing(false);
    }
  };

  const showBuyButton = !isOwnProduct && product.available && !['subscription', 'offer', 'tip_jar'].includes(product.listing_type);

  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <p className="text-4xl font-bold text-[#22C55E]" style={{ fontFamily: 'Cabinet Grotesk' }} data-testid="product-price">
          {formatCurrency(product.price)}
        </p>
        {product.available ? (
          <span className="flex items-center gap-1 text-sm text-[#00875A]">
            <Check className="w-4 h-4" />
            Available
          </span>
        ) : (
          <span className="text-sm text-[#FF3B30]">Not Available</span>
        )}
      </div>

      {showBuyButton && (
        <>
          <Button
            onClick={handlePurchase}
            disabled={purchasing}
            className="w-full bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-sm h-12 font-semibold text-lg"
            data-testid="purchase-button"
          >
            <ShoppingCart className="w-5 h-5 mr-2" />
            {purchasing ? 'Processing...' : `Buy for ${formatCurrency(product.price)}`}
          </Button>
          <div className="mt-3 flex items-center justify-center gap-3" data-testid="payment-methods-badges">
            <div className="flex items-center gap-1.5 text-[#6772E5]">
              <CreditCard className="w-4 h-4" weight="duotone" />
              <span className="text-[10px] font-medium">Card</span>
            </div>
            <span className="text-[#333333]">|</span>
            <div className="flex items-center gap-1 text-[#999999]">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C9.8 2 8 3.8 8 6s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 10c-4.4 0-8 1.8-8 4v2h16v-2c0-2.2-3.6-4-8-4z"/></svg>
              <span className="text-[10px] font-medium">Apple Pay</span>
            </div>
            <span className="text-[#333333]">|</span>
            <div className="flex items-center gap-1 text-[#00D632]">
              <Lightning className="w-4 h-4" weight="fill" />
              <span className="text-[10px] font-medium">Cash App</span>
            </div>
            <span className="text-[#333333]">|</span>
            <div className="flex items-center gap-1 text-[#0070BA]">
              <span className="text-[10px] font-bold">P</span>
              <span className="text-[10px] font-medium">PayPal / Venmo</span>
            </div>
          </div>
        </>
      )}
    </>
  );
}
